import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FadeTextOnWidthDirective } from '@shared/directives/fade-text-on-width.directive';

import { ReadOnlyFieldComponent } from './read-only-field.component';

@NgModule({
  declarations: [ReadOnlyFieldComponent],
  imports: [CommonModule, FadeTextOnWidthDirective, MatTooltipModule],
  exports: [ReadOnlyFieldComponent],
})
export class ReadOnlyFieldModule {}
